// For legacy browser, we always return true
export const getIsOnline = () =>
    window.navigator.onLine === undefined ? true : window.navigator.onLine;
